"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const query_string_1 = __importDefault(require("query-string"));
const react_idle_timer_1 = __importDefault(require("react-idle-timer"));
const styled_components_1 = __importDefault(require("styled-components"));
const styles_1 = require("@mui/material/styles");
const material_1 = require("@mui/material");
const react_router_dom_1 = require("react-router-dom");
const localeHelper_1 = require("../../../common/helpers/localeHelper");
const filterHelper_1 = __importDefault(require("../../../common/helpers/filterHelper"));
const services_1 = require("../../../common/services");
const themeHelper_1 = require("../../../common/helpers/themeHelper");
const helpers_1 = require("../../../common/helpers/helpers");
const withStore_1 = __importDefault(require("../../../common/decorators/withStore"));
const Loader_1 = __importDefault(require("../../../common/components/Loader/Loader"));
const VenueRoutes_1 = __importDefault(require("../Routes/VenueRoutes"));
const translations_1 = __importDefault(require("../../../common/translations"));
const pushService_1 = __importDefault(require("../../../common/services/pushService"));
const SimpleHeader_1 = __importDefault(require("../Header/SimpleHeader"));
const ModalGeneral_1 = __importDefault(require("../Modals/ModalGeneral"));
const SearchModal_1 = __importDefault(require("../Modals/SearchModal"));
const useUserToken_1 = require("../../behaviours/useUserToken");
const ErrorWrapper = styled_components_1.default.div `
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const Transition = react_1.default.forwardRef((props, ref) => {
    return react_1.default.createElement(material_1.Slide, Object.assign({ direction: "up", ref: ref }, props));
});
const TIME_UNTIL_USER_IS_CONSIDERED_IDLE = 18000000;
const IDLE_DEBOUNCE = 250;
const DISABLE_ACTIVITY_FETCH = false;
const USER_ACTIVATION_DELAY_MS = 30000;
const TOKEN_CREATED_AT_STORAGE_KEY = 'tokenCreatedAt';
const VenueLayout = (props) => {
    const [loaded, setLoaded] = (0, react_1.useState)(false);
    const [appError, setAppError] = (0, react_1.useState)('');
    const [theme, setTheme] = (0, react_1.useState)((0, styles_1.createTheme)());
    const [showRegistrationConfirmation, setShowRegistrationConfirmation] = (0, react_1.useState)(false);
    const [registrationMessage, setRegistrationMessage] = (0, react_1.useState)('');
    const { updateStore, match, location, userSelectedLocale, history, baseUrl, userData, kioskModeEnabled,
    // pushNotificationsEnabled,
     } = props;
    const isInitialLoad = (0, react_1.useRef)(true);
    const onIdle = () => {
        updateStore('userSelectedBubbleFilter', null);
    };
    const setupEnabledLocales = (venue) => {
        const enabledLocales = (0, localeHelper_1.getEnabledLocales)(venue);
        updateStore('enabledLocales', enabledLocales);
    };
    const setupInterestFiltering = (venue) => {
        if (!venue.interests) {
            updateStore('userSelectedInterests', []);
            return;
        }
        const bubbleFilters = filterHelper_1.default.getBubbleFilters(venue);
        const userSelectedInterests = filterHelper_1.default.getUserSelectedInterests(venue);
        updateStore('bubbleFilters', bubbleFilters);
        updateStore('userSelectedInterests', userSelectedInterests);
    };
    const setupTheming = (params) => __awaiter(void 0, void 0, void 0, function* () {
        const appThemeEnhanced = (0, themeHelper_1.getAppTheme)(params, params.appTheme);
        const isKiosk = window.location.pathname.includes('/guest_journey/kiosk');
        const fontBreakpoint = 820;
        setTheme((0, styles_1.createTheme)({
            palette: {
                // we set the mainAppColor as the primary color from backoffice
                // and the primary color as the secondary color from backoffice
                // we do it this way because the material library wants to set the primary color as a default for many small components and those components should be colored in the secondary color
                // main color theme of the app,
                mainAppColor: {
                    main: appThemeEnhanced.colorPrimary,
                    contrastText: appThemeEnhanced.colorOnPrimary,
                    light: appThemeEnhanced.colorPrimaryLighter,
                    dark: appThemeEnhanced.colorPrimaryDarker,
                },
                // used for buttons, inputs, CTA's styling, other various places where we need this accent
                primary: {
                    main: isKiosk ? appThemeEnhanced.colorPrimary : appThemeEnhanced.colorSecondary,
                    contrastText: isKiosk ? appThemeEnhanced.colorOnPrimary : appThemeEnhanced.colorOnSecondary,
                },
                secondary: {
                    main: appThemeEnhanced.colorSecondary,
                    contrastText: appThemeEnhanced.colorOnSecondary,
                },
                colorAppBar: {
                    main: appThemeEnhanced.colorAppBar,
                    contrastText: appThemeEnhanced.colorOnAppBar,
                },
                colorOnAppBar: {
                    main: appThemeEnhanced.colorOnAppBar,
                    contrastText: appThemeEnhanced.colorOnAppBar,
                },
                destroy: {
                    main: '#B00020',
                    contrastText: '#fff',
                },
                colorTiles: appThemeEnhanced.colorTiles,
                contrastThreshold: 3,
                tonalOffset: 0.2,
            },
            logo: appThemeEnhanced.logo,
            // MUI typography elements overwrite the font we set in the <head>, so we disable this behaviour by giving it an empty array
            typography: {
                fontFamily: [],
                h4: {
                    color: 'rgba(0,0,0,87%)',
                },
                h5: {
                    color: 'rgba(0,0,0,87%)',
                },
                h6: {
                    color: 'rgba(0,0,0,87%)',
                },
                body1: {
                    [`@media (min-width:${fontBreakpoint}px)`]: {
                        fontSize: '18px',
                    },
                    color: 'rgba(0,0,0,87%)',
                },
                body2: {
                    [`@media (min-width:${fontBreakpoint}px)`]: {
                        fontSize: '16px',
                    },
                    color: 'rgba(0,0,0,60%)',
                },
                caption: {
                    [`@media (min-width:${fontBreakpoint}px)`]: {
                        fontSize: '14px',
                    },
                    color: 'rgba(0,0,0,60%)',
                },
                overline: {
                    color: 'rgba(0,0,0,60%)',
                },
            },
            MuiButton: {
                root: {
                    fontWeight: 500,
                },
            },
        }));
        const currentThemeFont = document.getElementById('theme-font');
        if (currentThemeFont) {
            currentThemeFont.remove();
        }
        // We create a style tag in the head in which we add the theme font face
        // We do this because injecting the font face globally using styled components results in flickering on rerenders
        // https://github.com/styled-components/styled-components/issues/1593
        if (document && appThemeEnhanced.fontFamily) {
            const head = document.getElementsByTagName('head')[0];
            const style = document.createElement('style');
            style.setAttribute('id', 'theme-font');
            style.innerHTML = appThemeEnhanced.fontFamily;
            head.appendChild(style);
        }
    });
    const handleCloseDialog = () => {
        history.push(baseUrl);
    };
    const fetchNewData = () => {
        const promiseParams = {
            locale: props.currentLocale,
            userToken: userData.token,
        };
        const promises = [
            DISABLE_ACTIVITY_FETCH
                ? new Promise(resolve => {
                    resolve([]);
                })
                : services_1.apiService.getActivities(promiseParams),
            // apiService.getActivities( promiseParams ),
            services_1.apiService.getDirectory(promiseParams),
            services_1.apiService.getOffers(promiseParams),
        ];
        Promise.all(promises).then(apiResponse => {
            updateStore('unfilteredActivities', apiResponse[0]);
            updateStore('directory', apiResponse[1]);
            updateStore('offers', apiResponse[2]);
            updateStore('dataFetchCompleted', true);
        });
    };
    const checkForExistingUserToken = (clientId) => __awaiter(void 0, void 0, void 0, function* () {
        const inKiosk = window.location.pathname.includes('/guest_journey/kiosk');
        const tokenStorageKey = inKiosk ? 'kioskUserToken' : 'userToken';
        const existingToken = localStorage.getItem(tokenStorageKey);
        if (existingToken) {
            return existingToken;
        }
        const token = yield (0, useUserToken_1.useUserToken)({ clientId });
        localStorage.setItem(tokenStorageKey, token);
        if (inKiosk) {
            yield services_1.apiService.activateUser(token);
            yield pushService_1.default.disableInServer('en', token);
            return token;
        }
        localStorage.setItem(TOKEN_CREATED_AT_STORAGE_KEY, new Date().toISOString());
        setTimeout(() => {
            void (() => __awaiter(void 0, void 0, void 0, function* () {
                yield services_1.apiService.activateUser(token);
                // disable push service in server after user activations because the default for the push notifications is always true, at this moment it should always be false
                yield pushService_1.default.disableInServer('en', token);
            }))();
        }, USER_ACTIVATION_DELAY_MS);
        return token;
    });
    const checkinHotel = (locale, venueSlug, userToken) => __awaiter(void 0, void 0, void 0, function* () {
        const checkin = yield services_1.apiService.checkinUser(locale, userToken, venueSlug);
        return checkin.venue;
    });
    const initialSetup = () => __awaiter(void 0, void 0, void 0, function* () {
        updateStore('kioskModeEnabled', false);
        const browserLocale = navigator.language.length > 2 ? navigator.language.substring(0, 2) : navigator.language;
        const languageParameterApi = userSelectedLocale || browserLocale;
        const appData = (yield services_1.apiService.getAppData(languageParameterApi));
        updateStore('imprintUrl', appData.imprintUrl);
        const { slug } = match.params;
        const params = {
            slug,
            brand: appData.brandSlug,
            appTheme: Object.assign({}, appData.theme),
            logo: appData.logo,
        };
        const queryParams = query_string_1.default.parse(location.search);
        const userToken = yield checkForExistingUserToken(appData.brandId);
        const queryStringLocale = typeof queryParams.locale === 'object' ? queryParams.locale[0] : queryParams.locale;
        const currentCheckinVenue = yield checkinHotel(languageParameterApi, slug, userToken);
        if (currentCheckinVenue === false) {
            setAppError(translations_1.default.t('page_not_found'));
            setTimeout(() => {
                setLoaded(true);
            }, 100);
            return;
        }
        if (queryParams.status === 'failure' && queryParams.message) {
            setShowRegistrationConfirmation(true);
            setRegistrationMessage(queryParams.message);
        }
        const currentLocale = chooseCurrentLocale({
            browserLocale,
            queryStringLocale,
            userSelectedLocale,
            currentCheckinVenue,
        });
        if (appData.usercentricsApiKey) {
            helpers_1.Helpers.loadUsercentricsScript(() => { }, appData.usercentricsApiKey, currentLocale);
        }
        else {
            window.usercentrics = null;
        }
        const checkinVenueInCurrentLocale = (yield services_1.apiService.getCheckinVenue(currentLocale, userToken));
        helpers_1.Helpers.loadManifestByApp(checkinVenueInCurrentLocale.slug);
        document.title = checkinVenueInCurrentLocale.title;
        translations_1.default.defaultLocale = checkinVenueInCurrentLocale.defaultLocale;
        // when the translation is missing, set defaultLocale to "en"
        translations_1.default.missingTranslation = () => {
            translations_1.default.defaultLocale = 'en';
        };
        (0, localeHelper_1.setupInternationalization)(currentLocale, checkinVenueInCurrentLocale);
        const newUserData = yield services_1.apiService.getUserData(userToken);
        updateStore('userData', newUserData);
        // it's supposed that these 4 params could be provided when accessing the chat
        const queryStringParams = new URLSearchParams(window.location.search);
        const arrival = queryStringParams.get('arrival');
        const lastname = queryStringParams.get('lastname');
        const bookingId = queryStringParams.get('bookingId');
        const hotelmatchId = queryStringParams.get('hotelmatchId');
        if (arrival && lastname && bookingId && hotelmatchId) {
            const isLoggedIn = newUserData.loginProviders.length > 0 && newUserData.loginProviders[0].loggedIn;
            if (isLoggedIn) {
                yield services_1.apiService.addTuiStay(userToken, bookingId, lastname, arrival, hotelmatchId);
            }
        }
        pushService_1.default.registerServiceWorker();
        if (newUserData.pushNotificationEnabled) {
            try {
                const subscription = yield pushService_1.default.getSubscription();
                if (subscription) {
                    updateStore('pushNotificationsEnabled', true);
                }
                else {
                    pushService_1.default.disableInServer(currentLocale, newUserData.token);
                }
            }
            catch (error) {
                pushService_1.default.disableInServer(currentLocale, newUserData.token);
            }
        }
        const showCheckout = !appData.autocheckin || checkinVenueInCurrentLocale.slug !== appData.autocheckin;
        services_1.apiService.getNavigations(currentLocale, userToken).then((navigations) => {
            updateStore('navigations', navigations);
            updateStore('homeBottomCta', navigations.extras.homeBottomCta);
        });
        setupTheming(params);
        setupInterestFiltering(checkinVenueInCurrentLocale);
        setupEnabledLocales(checkinVenueInCurrentLocale);
        updateStore('appData', appData);
        updateStore('venue', checkinVenueInCurrentLocale);
        updateStore('hotelView', checkinVenueInCurrentLocale.hotelView);
        updateStore('showCheckout', showCheckout);
        updateStore('currentLocale', currentLocale);
        updateStore('baseUrl', match.url);
        updateStore('userLandedOn', location.pathname);
        updateStore('urlParams', match.params);
        updateStore('timezone', checkinVenueInCurrentLocale.timezone);
        updateStore('backofficeSettings', Object.assign(Object.assign({}, checkinVenueInCurrentLocale.settings), { dsEnableHandoverScreen: checkinVenueInCurrentLocale.dsEnableHandoverScreen, showWeather: checkinVenueInCurrentLocale.showWeather }));
        updateStore('appIds', {
            android: checkinVenueInCurrentLocale.androidBundleId
                ? checkinVenueInCurrentLocale.androidBundleId
                : appData.androidAppId,
            itunes: checkinVenueInCurrentLocale.itunesAppId ? checkinVenueInCurrentLocale.itunesAppId : appData.itunesId,
        });
        const promiseParams = Object.assign(Object.assign({}, params), { locale: currentLocale, userToken });
        const promises = [
            DISABLE_ACTIVITY_FETCH
                ? new Promise(resolve => {
                    resolve([]);
                })
                : services_1.apiService.getActivities(promiseParams),
            services_1.apiService.getWeather(promiseParams),
            services_1.apiService.getDirectory(promiseParams),
            services_1.apiService.getOffers(promiseParams),
        ];
        Promise.all(promises).then((apiResponse) => {
            isInitialLoad.current = false;
            const activitiesToShow = apiResponse[0].filter((activity) => activity.tags.indexOf('hide_on_app') === -1);
            const directoriesToShow = filterHelper_1.default.filterHiddenContentInTreeStructure(apiResponse[2]);
            const offersToShow = filterHelper_1.default.filterHiddenContentInTreeStructure(apiResponse[3]);
            updateStore('unfilteredActivities', activitiesToShow);
            updateStore('activitiesWereFetched', true);
            updateStore('weather', apiResponse[1]);
            updateStore('directory', directoriesToShow);
            updateStore('offers', offersToShow);
            updateStore('dataFetchCompleted', true);
        });
        setTimeout(() => {
            setLoaded(true);
        }, 100);
    });
    (0, react_1.useEffect)(() => {
        initialSetup();
    }, []);
    (0, react_1.useEffect)(() => {
        if (props.newDataFetchNeeded) {
            fetchNewData();
            updateStore('newDataFetchNeeded', false);
            updateStore('dataFetchCompleted', false);
        }
    }, [props.newDataFetchNeeded]);
    (0, react_1.useEffect)(() => {
        if (props.userSelectedLocale && !isInitialLoad.current) {
            setLoaded(false);
            initialSetup();
        }
    }, [props.userSelectedLocale]);
    if (!loaded) {
        return (react_1.default.createElement("div", { className: "overlay" },
            react_1.default.createElement(Loader_1.default, null)));
    }
    if (appError) {
        return react_1.default.createElement(ErrorWrapper, { "data-testid": "error-wrapper" }, appError);
    }
    const isBookingLinkoutSuccessPage = location.pathname.includes('/booking-linkout-success');
    return (react_1.default.createElement(styles_1.ThemeProvider, { theme: theme },
        react_1.default.createElement(react_idle_timer_1.default, { ref: null, element: document, onIdle: onIdle, debounce: IDLE_DEBOUNCE, timeout: TIME_UNTIL_USER_IS_CONSIDERED_IDLE }),
        react_1.default.createElement(react_1.default.Fragment, null,
            !kioskModeEnabled && !isBookingLinkoutSuccessPage && react_1.default.createElement(SimpleHeader_1.default, null),
            react_1.default.createElement(VenueRoutes_1.default, null),
            react_1.default.createElement(material_1.Dialog, { open: showRegistrationConfirmation, TransitionComponent: Transition, keepMounted: true, onClose: handleCloseDialog, "aria-describedby": "alert-dialog-slide-description" },
                react_1.default.createElement(material_1.DialogTitle, null, registrationMessage),
                react_1.default.createElement(material_1.DialogActions, null,
                    react_1.default.createElement(material_1.Button, { onClick: handleCloseDialog }, "Ok")))),
        react_1.default.createElement(ModalGeneral_1.default, null),
        react_1.default.createElement(SearchModal_1.default, null)));
};
// locale priority:
// 1. use user selected locale if present
// 2. use locale in the query string if present
// 3. use browser locale if present
// 4. use default locale present in the venue API response
function chooseCurrentLocale({ currentCheckinVenue, browserLocale, queryStringLocale, userSelectedLocale }) {
    if (userSelectedLocale && currentCheckinVenue.enabledLocales.includes(userSelectedLocale)) {
        return userSelectedLocale;
    }
    if (queryStringLocale && currentCheckinVenue.enabledLocales.includes(queryStringLocale)) {
        return queryStringLocale;
    }
    if (currentCheckinVenue.enabledLocales.includes(browserLocale)) {
        return browserLocale;
    }
    return currentCheckinVenue.defaultLocale;
}
const mapStoreToProps = store => ({
    userSelectedLocale: localStorage.getItem('language')
        ? localStorage.getItem('language')
        : store.getValue('userSelectedLocale'),
    newDataFetchNeeded: store.getValue('newDataFetchNeeded'),
    baseUrl: store.getValue('baseUrl'),
    backofficeSettings: store.getValue('backofficeSettings'),
    currentLocale: store.getValue('currentLocale'),
    userData: store.getValue('userData'),
    navigations: store.getValue('navigations'),
    kioskModeEnabled: store.getValue('kioskModeEnabled'),
});
exports.default = (0, react_router_dom_1.withRouter)((0, withStore_1.default)(mapStoreToProps)(VenueLayout));
